<template lang="html">
  <div class="main-down" v-if="el.showDown">
    <div class="name">
      {{message.Sl133}}
      <!-- <span class="icon" @click="close">
        &#xe846;
      </span> -->
    </div>
    <div class="box">
      <div class="cell">
        {{message.Al153}}
      </div>
      <div class="cell" style="text-align:center">
        <el-button type="primary" @click="downloadAssist">
          <a  class="download">{{message.Al152}}</a>
        </el-button>
      </div>
      <div class="cell">
        <span class="left" @click="toStart">{{message.Al154}}</span>
        <span class="right" @click="close">{{message.Al155}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      el: 'el',
      app: 'app'
    })
  },
  watch: {
    'el.showDown': function (val) {
      if (val) {
        this.$store.dispatch('activeAlive', false)
        this.$api.getDownloadUrl(response => {
          if (this._global.config.system === 'mac') {
            this.downloadUrl = response.mac
          } else {
            this.downloadUrl = response.win32
          }
        })
      }
    },
  },
  data () {
    return {
      message: {
        Sl133: this.$lang.ui.system.l133,
        Al152: this.$lang.ui.app.l152,
        Al153: this.$lang.ui.app.l153,
        Al154: this.$lang.ui.app.l154,
        Al155: this.$lang.ui.app.l155
      },
      downloadUrl: ''
    }
  },
  mounted () {
  },
  methods: {
    downloadAssist () {
      if (this.downloadUrl) {
        window.open(this.downloadUrl)
      } else {
        this.$store.dispatch('showDown', false)
        this.$store.dispatch('downloadMsg', 'none')
      }
    },
    toStart () {
      // this.$store.dispatch('passDown', true)
      this.$store.dispatch('alertWarn', true)
      this.$store.dispatch('activeAlive', true)
      this.$app.login(0, response => {
        if (response === 2) {
          this.$app.start()
        }
      })
      this.$store.dispatch('showDown', false)
    },
    close () {
      this.$store.dispatch('showDown', false)
    }
  }
}
</script>

<style lang="css" scoped>
.main-down {
  z-index: 9999;
  position: fixed;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin-left: -210px;
  margin-top: -130px;
  top: 42%;
  left: 50%;
  width: 420px;
  height: auto;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
}
.name {
  position: relative;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0291cf;
}
.name span {
  position: absolute;
  top: 0;
  right: 18px;
  height: 100%;
  display: block;
  color: #fff;
  float: right;
  font-size: 21px;
  cursor: pointer;
}
.name span:hover {
  font-size: 25px;
}
.box {
  width: 100%;
  padding: 20px 40px 14px 40px;
}
.cell {
  width: 100%;
  padding: 12px 0;
  text-align: center;
  overflow: hidden;
}
.download {
  color: #fff;
  text-decoration: none;
}
.cell span {
  display: block;
  cursor: pointer;
  font-size: 12px;
  width: 155px;
  text-align: center;
  color: #0291cf;
}
.left {
  float: left;
}
.right {
  float: right;
}
</style>
